import { Model, RailsFormat } from "./model";

export class TwoWeekBlock extends Model implements RailsFormat {

  constructor(
    public termId: number = 0,
    public index: number = 0,
    public startDate: Date = null,
    public endDate: Date = null,
    public secondWeekStart: Date = null,
    public name: string = "",

  ) { super(); }

  static clone(obj: any) {
    const wb = new this()

    if (obj.termId) { wb.termId = obj.termId }
    if (obj.index) { wb.index = obj.index }
    if (obj.startDate) { wb.startDate = obj.startDate }
    if (obj.endDate) { wb.endDate = obj.endDate }
    if (obj.secondWeekStart) { wb.secondWeekStart = new Date(obj.secondWeekStart) }
    if (obj.name) { wb.name = obj.name }

    return wb
  }

  serializeForRails() {
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/two-week-block.ts